import {U, __, WARNING, short_popup, JOBS} from "./global";
import {CARD} from "./card";
import {GTM} from "./gtm";
import {CABINET} from "./cabinet";
import Cookies from 'js-cookie';
import {SHOWCASE} from "./showcase";
import {DRAWER} from "./drawer";
import {EX} from "./exchange";
import {CF, init_CF_events} from "./clientfinder";

export const SLR = {
    washandinput: false,
    token_counter: 0,
    token: '',
    count_stock: 0,
    count_nostock: 0,
    smstrycount: 0,
    smstrysecond: 40,
    smstrytimeout: 5000,
    smstimeout: false,
    searchtimeoutdelay: 900,
    searchtimeout: false,
    promo_data: '',

    selectedDeviceId: false,
    addBlocked: false,
    codeReader: {},
    sound_enabled: true,
    cameraLoading: false,
    finded_client: {},
    isLoading: false,

    clear_exchange_storage: function(imei, passport) {
        this.write_exchange_storage('', '');
    },

    write_exchange_storage: function(imei, passport) {
        localStorage.setItem('slr_exchange_selected', JSON.stringify({
            imei,
            passport
        }));
    },

    fill_exchange_storage: function() {
        const obj = JSON.parse(localStorage.getItem('slr_exchange_selected'));

        if (obj?.imei) {
            $(".slr-exchangeform [name=imei]").val(obj.imei);
        }

        if (obj?.passport) {
            $(".slr-exchangeform [name=passport]").val(obj.passport);
        }
    },

    camera_click_effect: function() {
        let audio = new Audio('/themes/img/camera_click.mp3');
        audio.play();

        $(".camera-layout__video").append('<div class="camera-layout__effect"></div>');

        setTimeout(function(){
            $(".camera-layout__effect").addClass('show');
        }, 200);
        setTimeout(function(){
            $(".camera-layout__effect").remove();
        }, 1000);
    },

    add_qr_sku: function(text) {
        this.setCameraLoader(true);

        $.ajax({
            type: "POST",
            url: "/aj",
            data: {
                action: 'slr',
                to: 'processqr',
                text: text
            },
            dataType: "json",
            timeout: 15000, // in milliseconds
            success: (data) => {
                this.setCameraLoader(false);

                $(".camera-layout__results").append('<div class="camera-layout__sku" data-sku="' + data.sku + '">' + data.sku + '</div>');

                if ($(".body-camera-layout").data('count')==1) {
                    $(".camera-layout__add").trigger('click');
                }

                if (this.sound_enabled)
                    this.camera_click_effect();
            },
            error: function(data) {
                SLR.setCameraLoader(false);
                alert('Код не розпізнано ' + text);
            }
        });
    },

    setCameraLoader: function(to) {
        this.cameraLoading = to;

        if (to) {
            $(".camera-layout").addClass('camera-layout--loading');
        } else {
            $(".camera-layout").removeClass('camera-layout--loading');
        }
    },

    lookupClientByGuid: function(guid) {
        this.setCameraLoader(true);

        CARD.postData({
            action: 'slr',
            to: 'findclientbyguid',
            guid
        }).then(res => {
            if (res.success) {
                // confirm
                $(".cameraclient").remove();

                // language=HTML
                $("body").append(`
                    <div class="cameraclient">
                        <div>
                            <div class="title">${res.name}</div>
                            <div style="color: #F44C4C;margin-bottom: 4px;">🎁 ${res.birthday}</div>
                            <div style="color: #C05100;margin-bottom: 8px;">📞 ${res.phone}</div>
                            <div class="bonuses">${res.bonus} бонусів</div>
                            <br />
                            <br />

                            <center>
                                <button class="btn unsuccess js-cameraclient__close">Ні</button>&nbsp;&nbsp;&nbsp;
                                <button class="btn js-cameraclient__yes">Так</button>
                            </center>              
                        </div>
                    </div>
                `)

                SLR.finded_client = res;
                // SLR.set_client(res.code, res.name);
            } else {
                alert('Кліент не знайдений');
            }
        }).catch(err => {
            alert('Кліент не знайдений');
        }).finally(() => {
            this.setCameraLoader(false);
        });
    },

    // check
    possible_submit: function() {
        let result = false;

        if (!($(".cart [name=payment]")=='') && !($(".cart [name=code]")==0))
            result = true;

        if (!$(".cart .user-register").hasClass('hidden'))
            result = false;

        if (G.channel==1) {
            let phone = $(".cart .scroll").find("[name=phone]");
            if (!(phone.val().replace(/[^\d]/g, '').length==10))
                result = false;
        }

        if (result)
            $(".submit-order").addClass('active');
        else
            $(".submit-order").removeClass('active');

        return result;
    },

    // check
    lookup_user: function(phone, place = 'checkout') {
        let phone_container = $(".cart [name=phone]");
        let form = phone_container.parents('form');
        phone_container.prop('disabled', true).parent().addClass('loading');

        if (this.isLoading)
            return;

        this.isLoading = true;

        CARD.setLoading(true);

        return CARD.postData({
            action: 'slr',
            to: 'finduserbyphone',
            phone,
            place
        }).then(data => {
            phone_container.prop('disabled', false).parent().removeClass('loading');

            if (data.users.length) {
                phone_container.parent().parent().find('label span').addClass('success').removeClass('error').html('Знайдено').removeClass('hidden');

                $.post(
                    '/slr/lastclients',
                    {
                        to: 'lastclients',
                        phone: phone
                    },
                    (result) => {
                        if (!$(".client-finder .client-list .last-clients-container").length)
                            $(".client-finder .client-list").append('<div class="last-clients-container"></div>');

                        $(".last-clients-container").replaceWith(result.html);
                        $(".last-clients-container [data-code=" + data.users[0].code + "]").trigger('click');
                    },
                    'json'
                );
                form.find('.confirmation-button').addClass('hidden');
                form.find(".user-register").addClass('hidden');
                form.find('.confirmation-field').addClass('hidden');
                form.find('.confirmation-success-send').addClass('hidden');
            } else {
                clearInterval(this.smstimeout);
                $(".confirmation-button button").removeClass('cancel').addClass('success').html('Зареєструвати');

                phone_container.parent().parent().find('label span').removeClass('success').addClass('error').html('Не знайдено').removeClass('hidden');

                // register part
                $(".client-finder >div >.symbols").remove();
                form.find('[name=code]').val(0).trigger('change');
                form.find('[name=codename]').val('').trigger('change');
                form.find('.confirmation-button').removeClass('hidden');
                $(".client-finder").removeClass('exists').find(".title").html(__('Приватний клієнт'));

                if (data.error!='') {
                    $(".confirmation-success-send").removeClass('hidden').addClass('alert-danger').html(data.error);
                }
            }

            $(".cart .scroll .error-alert").addClass('hidden');

            this.possible_submit();

            CARD.updatePromise().then(() => {
                CARD.update_bonuses(true);
            });
        }).finally(() => {
            CARD.setLoading(false);
            this.isLoading = false;
            $(".cart .sku-search input").val('');
        });
    },

    // check
    startSmsTimer: function() {
        this.smstrysecond = 30;

        if (this.smstrycount > 1)
            this.smstrysecond = 30;

        if (this.smstrycount > 2) {
            $(".confirmation-button button").removeClass('cancel').addClass('success').html('Дзвінок КЦ').data('cc', 1);
        } else {
            this.smstimeout = setInterval(() => {
                this.smstrysecond--;

                if (this.smstrysecond < 1) {
                    clearInterval(this.smstimeout);
                    $(".confirmation-button button").removeClass('cancel').addClass('success').html('Повторити');
                } else {
                    $(".confirmation-button button").html(this.smstrysecond);
                }
            }, 1000);
        }
    },

    // check
    make_order: function(parentform){

        CARD.onorderpage = true;

        if (!(CARD.count_items > 0 && (CARD.sum.uah > 0 || CARD.sum.usd > 0))) {
            parentform.find('.js-carterror').removeClass('hidden').html(__('Перевірте вміст кошика'));
            return;
        }

        $(".fired-container").removeClass('opened');
        let payment = $(".cart [name=payment]").val();
        let data = $(".cart .scroll form").serializeAny();

        parentform.find('[type=submit]').addClass('loading');

        // bonuses
        let use_bonuses = `&use_bonuses=${CARD.available_bonuses.amount > 0 && $(".js-cart__usebonus").hasClass('active') && $(".cart__usebonusamount input").val() && !$(".cart__usebonus").hasClass('cart__usebonus-loading') ? $(".cart__usebonusamount input").val() : 0}`;

        // process checkout
        if ($(".credit__listitem-active .js-slrproceedcheckout input:checked").length > 0) {
            if (!$(".credit__listitem-active .js-slrproceedcheckout").hasClass('hidden')) {
                data = `${data}&proceed_payment=1`;
            }
        }

        $.ajax({
            type: "POST",
            url: "/aj",
            data: 'action=basket&to=order&locale='+G.locale_id+'&count_stock='+this.count_stock+'&count_nostock='+this.count_nostock+CARD.sumParam()+'&count_items='+CARD.count_items+'&page='+document.location.pathname+'&' + data + use_bonuses,
            dataType: "json",
            timeout: 40000, // in milliseconds
            success: (data) => {
                parentform.find('[type=submit]').removeClass('loading');

                if (data.payment_problem) {
                    parentform.find('.js-carterror').removeClass('hidden').html(data.error);
                    CARD.onorderpage = false;

                    CARD.reshow_mobile_payment_buttons();
                    return;
                }

                if (!data.success) {
                    parentform.find('.js-carterror').removeClass('hidden').html(data.error);
                    CARD.onorderpage = false;

                    CARD.reshow_mobile_payment_buttons();
                    return;
                }

                CARD.makeOrderHook(data, payment);
                CARD.block_checkout(false);
                return false;
            },
            error: function(request, status, err) {
                parentform.find('.js-carterror').removeClass('hidden').html(`Проблеми з створенням замовлення. Зв'яжіться з розробниками. Lead: ${CARD.lead_id}`);
                parentform.find('[type=submit]').removeClass('loading');
                CARD.firstopened = false;
            }
        });
    },

    open_checkout_hook: function(data) {

        CARD.window('process-checkout', data.window);

        if ($(".delivery__method.active").length)
            $(".delivery__method.active").trigger('click');

        $(".pm-data[data-block=cashless] select").select2({minimumResultsForSearch: Infinity}).trigger('change');

        CARD.init_city_choise();

        CARD.update_bonuses(true);
        this.check_process_checkout_button();
        this.possible_submit();
    },

    // check
    cardHook: function(data) {
        if (!(typeof data==="undefined") && !(typeof data.slr==="undefined")) {
            this.count_stock = data.slr.count_stock;
            this.count_nostock = data.slr.count_nostock;

            $(".cart__title .js-cart__clienttop").remove();

            $(".cart__title").append(`<div class="cart__clienttop js-cart__clienttop ellipsis1">${data.slr.client.name}</div>`);
        }
    },

    // check
    paymentHook: function() {
        this.possible_submit();
    },

    // check
    updateBonuses: function() {
        $(".client-finder .bonuses").html('<a href="#" class="loading typical process-loading"></a>');
        CARD.set_bonus_loading(true);

        $.post(
            '/slr/finduserbyphone',
            {
                to: 'finduserbyphone',
                phone: $(".cart [name=phone]").val().replace(/[^\d]/g, '')
            },
            function(data){
                if (data.users.length) {
                    let html = data.users[0].bonus_str;

                    if (data.users[0].bonus_limited_details.length)
                        $.each(data.users[0].bonus_limited_details, function(i, item){
                            html += '<br /><b>' + item.amount + '</b> ' + item.type;
                        });

                    $(".client-finder .bonuses").html(html);

                    CARD.update_bonuses(true);
                } else {
                    $(".client-finder .bonuses").html('Бонуси: 0');
                }
            },
            'json'
        );
    },

    // check
    fillSearch: function() {
        let input = $(".cart .sku-search input");

        let container = $(".cart .search-goods");
        let val = $.trim(input.val());
        let reg = new RegExp(val, 'gi');

        if (val.length > 2)
            $.post(
                '/aj',
                {
                    action: 'slr',
                    locale: G.locale_id,
                    to: 'findsku',
                    q: val,
                },
                function(data){

                    let cc = 0;
                    container.empty().removeClass('load-animation').append('<div class="sku-list"></div>');
                    let max = data.result.length ? 5 : 10

                    if (data.items.length) {
                        let counter = 0;
                        $.each(data.items, function (i, item) {
                            if (counter==max)
                                return;

                            let stickers = '';

                            if (item.ss)
                                stickers += '<span class="home">+</span>';

                            if (item.sm)
                                stickers += '<span class="point">' + item.sm + '</span>';

                            if (item.so)
                                stickers += '<span class="home">' + item.so + '</span>';

                            if (stickers.length)
                                stickers = '<div class="availability">' + stickers + '</div>';

                            counter++;
                            cc++;
                            let str = '<strong>' + item.sku + '</strong>&nbsp;&nbsp;&nbsp;' + item.title;
                            str = str.replace(reg, function(str) {return '<font class="highlight-search">'+str+'</font>'});
                            container.find('.sku-list').append('<a href="javascript: void(null);" class="unexisted" data-sku="' + item.sku + '">' + str + stickers + '</a>');
                        });
                    }

                    if (data.result.length) {
                        let counter = 0;
                        max = 8 - (cc > 3 ? 3 : cc);
                        let desctop_maximum = 15;
                        $.each(data.result, function(i, item){
                            if (cc==desctop_maximum)
                                return;

                            var stickers = '';

                            if (item.ss)
                                stickers += '<span class="home">+</span>';

                            if (item.sm)
                                stickers += '<span class="point">' + item.sm + '</span>';

                            if (item.so)
                                stickers += '<span class="home">' + item.so + '</span>';

                            if (stickers.length)
                                stickers = '<div class="availability">' + stickers + '</div>';

                            counter++;
                            cc++;
                            let str = '<strong>' + item.sku + '</strong>&nbsp;&nbsp;&nbsp;' + item.title;
                            str = str.replace(reg, function(str) {return '<font class="highlight-search">'+str+'</font>'});
                            container.find('.sku-list').append('<a href="javascript: void(null);" data-sku="'+item.sku+'">' + str + stickers + '</a>');
                        });

                        container.append(`<a class="typical" style="display: block; margin: 0px auto 20px auto; text-align: center;" href="/search/?q=${val}">Пошук сайту</a>`);
                    }

                    if (cc==0)
                        container.addClass('hidden');
                    else
                        container.removeClass('hidden');
                },
                'json'
        );
    },

    /**
     * Функція для перевірки чи ж кліент, щоб дозволити оплату онлайн (процесінг банків) для SLR
     */
    check_process_checkout_button: function() {
        let code = parseInt($(".cart.ok [name=code]").val());

        console.log(code);
        if (code > 0) {
            $(".js-slrproceedcheckout").removeClass("hidden");
        } else {
            $(".js-slrproceedcheckout").addClass("hidden");
        }
    },

    show_readonly_hook: function(readonly) {
        if (readonly.has_success_payment && readonly.process_checkout) {
            // закриваємо замовлення в SLR

            const html = `<div class="monobank-process">
                        <div class="loaderblock margin-auto"></div>
                        <div class="clearfix"></div>
                        <br />
        
                        <h3>Очікуйте</h3>
                        <p>Створюємо замовлення в 1с</p>
                    </div>`;

            $(".cart__readonly").html(html);

            CARD.postData({
                action: 'basket',
                to: 'slr_make_order'
            }, '/aj', 40000).then(res => {
                if (res.success) {
                    CARD.show_thx(CARD.lead_id).then(() => {
                        $(".cart .checkout").addClass('thx');
                        $(".cart").removeClass('cart-readonly');
                        $(".cart__readonly").remove();
                    });
                } else {
                    $(".cart__readonly").html(`
                        <div>
                        <h2>Оплата не отримана</h2>
                        <p>${res.error}</p>
                        <button class="btn btn-red js-cart__declinepayment">Скасувати</button>
                        </div>
                    `)
                }
            }).catch(err => {
                CARD.updatePromise();
            }).finally(() => {

            });
        }
    },

    after_payment_hook: function() {
        // $(".cart").removeClass('cart__waiting cart__waiting-portmone');
        //                                     this.show_thx(this.lead_id);

        const form =  $(".cart .checkout form");

        $(".cart .scroll").addClass('hidden');
        $(".cart .checkout").find('.js-sellerordercreate').remove();
        $(".cart .checkout").append(`
            <div class="scroll js-sellerordercreate">
                <div class="wrap">
                    <div class="monobank-process">
                        <div class="loaderblock margin-auto"></div>
                        <div class="clearfix"></div>
                        <br />
        
                        <h3>Очікуйте</h3>
                        <p>Створюємо замовлення в 1с</p>
                    </div>
                </div>
                <div class="wrap-wide"></div>
            </div>
        `);

        CARD.postData({
            action: 'basket',
            to: 'slr_make_order'
        }, '/aj', 40000).then(res => {
            if (res.success) {
                CARD.show_thx(CARD.lead_id).then(() => {
                    $(".cart .checkout").addClass('thx');
                });
            } else {
                $(".cart .scroll").removeClass('hidden');
                form.find('.js-carterror').addClass('alert-danger').removeClass('hidden').html(res.error);
            }
        }).catch(err => {
            $(".cart .scroll").removeClass('hidden');
            form.find('.js-carterror').addClass('alert-danger').removeClass('hidden').html(`Не вдалось створити замовлення ${CARD.lead_id}`);
            CARD.onorderpage = false;
            CARD.reshow_mobile_payment_buttons();
        }).finally(() => {
            $(".js-sellerordercreate").remove();
            $(".monobank-approve-form, .abank-approve-form, .payparts-approve-form").remove();
            $(".cart").removeClass('cart__waiting cart__waiting-portmone');
        });
    },

    /**
     * Хук після установки методів оплати
     */
    set_payment_methods_hook: function() {
        this.check_process_checkout_button();
    },

    // check
    set_client: function(code, name){
        $.post(
            '/aj',
            {
                action: 'slr',
                to: 'saveselectedclient',
                code: code,
                name: name,
            },
            (result) => {
                $(".cart.ok [name=code]").val(code);
                $(".cart.ok [name=phone]").val(result.phone);

                if (code) {
                    $(".client-finder .title").html(name);
                    $(".client-finder .bonuses").html('<a href="#" class="typical loading"></a>');
                    $(".client-finder").addClass('exists');
                } else
                    $(".client-finder").removeClass('exists').find(".title").html(__('Приватний клієнт'));

                $(".cart .scroll .error-alert").addClass('hidden');

                CARD.onorderpage = 1;
                CARD.updatePromise().then(() => {
                    CARD.update_bonuses(true);
                    SLR.check_process_checkout_button();
                    this.possible_submit();
                });
            },
            'json'
        );
    }
};

export const UNPACK = {
    productCache: null,

    container: $('.js-unpackresults'),
    search_timeout: false,

    filter_goods: function(query) {
        clearTimeout(this.search_timeout);

        query = $.trim(query.toString().toLowerCase());
        const hasText = /\D/.test(query);

        if (query=='') {
            $(".js-looplist .loop").removeClass('hidden');
            $(".js-unpack-form [type=submit]").prop('disabled', false);
        } else {
            this.search_timeout = setTimeout(() => {
                $.each($(".js-looplist .loop"), (i, item) => {
                    item = $(item);
                    const sku = item.find('.js-skus').text().toString().toLowerCase();
                    const title = item.find('.loop__title').text().toString().toLowerCase();

                    if (sku.includes(query) || (hasText && title.includes(query))) {
                        item.removeClass('hidden');
                    } else {
                        item.addClass('hidden');
                    }
                });
            }, 300);

            if (hasText) {
                $(".js-unpack-form [type=submit]").prop('disabled', true);
            }
        }
    },

    loader: function(set = true){
        return;
        this.container.empty().append('<div class="loaderblock"></div>')
    },

    send: function() {
        const form = $(".js-unpack-sendform");
        const comment = form.find('[name=comment]').val();
        const reason = form.find('[name=reason]').val();
        const opened = form.find('[name=opened]').val();
        const sn_guid = form.find("[name=sn_guid]").val();
        const sku = form.find("[name=sku]").val();

        return CARD.postData({
            action: 'slr',
            to: 'unpack',
            sku,
            sn_guid,
            comment,
            opened,
            reason
        }, '/slr/unpack/send', 5000);
    },

    showUnpackButton: function(show = true) {
        return;
        if (show) {
            $(".js-unpack-unpackbtn").removeClass('hidden');
        } else {
            $(".js-unpack-unpackbtn").addClass('hidden');
        }
    },

    lookupsku: function(sku, form) {
        this.loader();
        this.showUnpackButton(false);
        this.container.find('.alert').remove();
        this.container.find('[name=sku]').parent().removeClass('form-item-error');

        const btn = form.find('[type=submit]');

        if (btn.prop('disabled')) {
            return;
        }

        btn.prop('disabled', true).addClass('btn-loading');

        JOBS.init_JOB(
            '/slr/unpack/lookupsku',
            {
                action: 'slr',
                to: 'unpack',
                sku: sku
            },
            (res) => {
                this.container.empty();

                if (res.success) {
                    this.productCache = res.product;
                    // this.container.append(this.product(res.product));
                    $(".js-unpack-unpackbtn").trigger('click');
                    this.showUnpackButton(true);
                } else {
                    console.error(res);
                    this.container.find('[name=sku]').parent().addClass('form-item-error');
                    this.container.append('<div class="alert alert-danger">Товар не знайдено</div>');
                }
            },
            (result) => {
                this.container.find('[name=sku]').parent().addClass('form-item-error');
                this.container.append('<div class="alert alert-danger">Товар не знайдено</div>');
            },
            () => {
                btn.prop('disabled', false).removeClass('btn-loading');
            }
        );
    },

    product: function(product) {
        let res = $(`
            <div class="unpack__product">
                <div class="unpack__top">
                    <div>
                        <img src="${product.image}" />
                    </div>
                    <div>
                        <h4>${product.title}</h4>
                        <strong>${product.nomenclature_code}</strong>
                    </div>
                </div>
                
                <div class="unpack__ss">
                
                </div>
            </div>
        `);

        product.serial_numbers.map(item => {
            if (!item.opened) {
                res.find('.unpack__ss').append(`<div>
                    <strong>${item.opened ? `Відкритий` : `Запакований`}</strong><br />
                    Серійний номер ${item.sn_code}
                    ${item.comment != '' ? `<br /><i>${item.comment}</i>` : ``}
                    
                    <hr />
                </div>`);
            }
        });

        return res;
    },

    filterSerialNumbers: function(word = '')
    {
        $.each($(".js-unpack-serialslist >a"), function(i, item) {
            item = $(item);

            if (word != '') {
                console.log(item, item.data());
                if (item.data('serial').toString().toLowerCase().includes(word.toString().toLowerCase())) {
                    const regex = new RegExp(`(${word})`, 'gi');
                    const highlighted = item.data('serial').toString().replace(regex, '<strong>$1</strong>');
                    item.removeClass('hidden').find('.js-ssnumber').html(highlighted);
                } else {
                    item.addClass('hidden');
                }
            } else {
                item.removeClass('hidden').find('.js-ssnumber').html(item.data('serial'));
            }
        });

        if ($(".js-unpack-serialslist >a:not(.hidden)").length==1) {
            $(".js-unpack-unpackserial").removeClass('hidden');
        } else {
            $(".js-unpack-unpackserial").addClass('hidden');
        }
    },
}

export function init_SLR_events() {
    jQuery(document).ready(function () {

        // daypromo contexts
        $(".wrapper-cabinet-slr-promo .blog-categories a").click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);

            btn.parent().find('a').removeClass('active');
            btn.addClass('active');

            if (SLR.promo_data == '')
                SLR.promo_data = $(".promo__biglist").html();

            $(".promo__biglist").empty().html(SLR.promo_data);

            if ($(".blog-categories-slr-business a.active").length > 0 && $(".blog-categories-slr-business a.active").data('context') != '0') {
                $(".promo__biglist >div:not([data-business*=" + $(".blog-categories-slr-business a.active").data('context') + "])").remove();
            }

            if ($(".blog-categories-slr-promo a.active").length > 0 && $(".blog-categories-slr-promo a.active").data('context') != '0') {
                $(".promo__biglist >div:not([data-context*=" + $(".blog-categories-slr-promo a.active").data('context') + "])").remove();
            }

        });

        // open chose cart
        jQuery("body").on("click", ".cart .change-cart", function (e) {
            e.preventDefault();

            if ($(".cart .chose-cart-container").length) {
                $(".cart .chose-cart-container").remove();
                $(".change-cart").removeClass('active');
            } else {
                $(".change-cart").addClass('active');
                $.post(
                    '/aj',
                    {
                        action: 'slr',
                        to: 'chosecart',
                        locale: G.locale_id
                    },
                    function (data) {
                        $(".cart__content").append('<div class="chose-cart-container">' + data.html + '</div>');
                    },
                    'json'
                );
            }
        });

        // make new cart
        jQuery("body").on("click", ".cart .js-makenewcart", function (e) {
            e.preventDefault();
            $.post(
                '/aj',
                {
                    action: 'slr',
                    to: 'setnewcart',
                    leadid: 'newcart',
                    locale: G.locale_id
                },
                function (data) {
                    CARD.updatePromise().then(() => {
                        $(".cart .change-cart").trigger('click');
                    });
                }, 'json');
        });

        // select cart
        jQuery("body").on("click", ".cart-list >div", function (e) {
            e.preventDefault();
            e.stopPropagation();

            CARD.setLoading(true);

            $(".cart .chose-cart-container").remove();
            $(".change-cart").removeClass('active');

            $.post(
                '/aj',
                {
                    action: 'slr',
                    to: 'setnewcart',
                    leadid: $(this).data('lead'),
                    locale: G.locale_id
                },
                function (data) {
                    CARD.setLoading(false);
                    CARD.updatePromise();
                }, 'json');
        });

        // slr keypress autocomplete add sku desktop
        jQuery("body").on("keyup", ".cart .sku-search input", function (e) {
            // console.log(e);
            let input = $(this);
            let val = $.trim(input.val());

            if (e.type!='change') {
                $(".cart .search-goods").empty().addClass('hidden');
            }

            if ($(".change-cart").hasClass('active'))
                $(".change-cart").trigger('click');

            clearTimeout(SLR.searchtimeout);

            if (val.substring(0, 1)=='-' || val.substring(0, 1)=='+') {
                e.preventDefault();
                e.stopPropagation();

                if (val.length==11) {
                    return SLR.lookup_user(val.replace(/[^\d]/g, ''), 'cart');
                }
            } else {
                if (e.keyCode == 13) {
                    e.preventDefault();
                    e.stopPropagation();

                    CARD.add(val, 0, '', '', 1, () => {
                        input.val('').blur();
                    });
                    return;
                }

                if (val.length > 2 && e.type!='change') {
                    if (!$(".cart .search-goods").length)
                        $(".cart .bottom").prepend('<div class="search-goods"></div>');

                    $(".cart .search-goods").empty().removeClass('hidden').addClass('load-animation');

                    SLR.searchtimeout = setTimeout(function () {
                        SLR.fillSearch()
                    }, SLR.searchtimeoutdelay);
                }
            }

            return;
        });

        // добавить товар в корзину из поиска
        jQuery("body").on("click", ".cart .search-goods .sku-list a", function (e) {
            e.preventDefault();

            let btn = $(this);
            let sku = btn.data('sku');

            CARD.add(sku, 1, '', '', 1, function () {
                $(".cart .sku-search input").val('');
                $(".cart .search-goods").addClass('hidden');
            });
        });

        // добавить товар в корзину из поиска
        jQuery("body").on("click", ".cart .qr-sku-close", function (e) {
            e.preventDefault();
            e.stopPropagation();

            $(".sku-search input").val('').trigger('keyup').trigger('blur');
        });

        // открываем выбор клиента
        jQuery("body").on("click", ".cart .client-finder a.title", function (e) {
            e.preventDefault();
            $(this).parent().parent().toggleClass('active');
        });

        // используем бонусы
        jQuery("body").on("click", ".cart .bonus-counter", function (e) {
            e.preventDefault();
            let btn = $(this);

            if (btn.hasClass('active')) {
                $(".cart [name=use_bonuses]").val(0);
                btn.removeClass('active');
            } else {
                btn.addClass('active');
                $(".cart [name=use_bonuses]").val(1);
            }
        });

        // только запакованное
        jQuery("body").on("click", ".cart .packed-only", function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $(".cart [name=packed_only]").val($(".cart [name=packed_only]").val() == 1 ? 0 : 1);
        });

        if (Cookies.get('slrafterlogin')) {
            GTM.event('slrauth', Cookies.get('slrafterlogin'), Cookies.get('slrstore'));
            Cookies.remove('slrafterlogin');
            Cookies.remove('slrstore');
        }

        // ввод номера телефона
        jQuery("body").on("keyup", ".cart.ok [name=phone]", function (e) {
            let input = $(this);

            $(".cart .scroll .error-alert").addClass('hidden');

            if (G.channel == 1) {
                SLR.possible_submit();
            }

            const phone = input.val().replace(/[^\d]/g, '');

            if (phone.length == 10 && CF.last_phone_number!=phone) {
                CF.last_phone_number = phone;
                SLR.lookup_user(phone);
            }
        });

        // выбор клиента
        jQuery("body").on("click", ".last-clients-container .client", function (e) {
            e.preventDefault();

            let container = $(this);
            let name = container.find('.user-name').text();
            const _container = container.parents('.cf').length > 0 ? $(".cf") : $(".client-finder");

            if (container.parents('.cf').length > 0) {
                CF.set_client(container.data('code'), name);
            } else {
                SLR.set_client(container.data('code'), name);
            }

            _container.removeClass('active');
            $(">div >.symbols", _container).remove();

            let symbols = [];
            name = name.split(' ');

            if (name.length)
                $.each(name, function (i, item) {
                    symbols.push(item.substr(0, 1));
                });

            if (symbols.length) {
                symbols = symbols.slice(0, 2);
                $(">div", _container).prepend('<div class="symbols">' + symbols.join('') + '</div>');
            }
        });

        // выбор приватного клиента
        jQuery("body").on("click", ".client-list .private-client", function (e) {
            e.preventDefault();

            let container = $(this);
            SLR.set_client(container.data('code'), container.find('.user-name').text());
            $(".client-finder").removeClass('active');
            $(".client-finder >div >.symbols").remove();
        });

        // изменение метода оплаты
        jQuery("body").on("change", ".cart__payment [name=payment]", function (e) {
            $(".cart .scroll .error-alert").addClass('hidden');
            SLR.possible_submit();
        });

        // update bonuses
        jQuery("body").on("click", ".client-finder .bonuses", function (e) {
            e.preventDefault();
            SLR.updateBonuses();
        });

        jQuery("body").on("click", ".client-finder .bonuses a", function (e) {
            e.preventDefault();
        });

        // Отправка заказа
        jQuery("body").on("click", ".submit-order", function (e) {
            e.preventDefault();

            let btn = $(this);

            if (!(!btn.hasClass('active') || btn.hasClass('loading'))) {
                let form = $(".cart.ok .checkout form");
                let errors_count = 0;

                let phone = form.find("[name=phone]");
                let code = form.find("[name=code]");
                let cc = form.find("[name=cc]");
                let phoneno = /^\(?([0-9]{2})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{2})[-. ]?([0-9]{2})$/;

                if (code.val() > 0 || (code.val() < 1 && !phone.val().match(phoneno)) || cc.prop('checked')) {

                    if (errors_count) {
                        form.find('.js-carterror').html(__('Перевірте форму. Усі данні мають бути заповнені.')).removeClass('hidden');
                        return false;
                    } else
                        form.find('.js-carterror').addClass('hidden');

                    CARD.save_all_delivery()
                        .then(() => {
                            SLR.make_order(form);
                        });
                } else
                    form.find('.js-carterror').html(__('Клієнт не обраний')).removeClass('hidden');
            }
        });

        // Отправка запроса на смс (регистрация slr)
        jQuery("body").on("click", ".cart.ok .confirmation-button button", function (e) {
            e.preventDefault();

            let btn = $(this);
            let form = btn.parents('form');
            let phone = form.find("[name=phone]");

            if (!btn.hasClass('success'))
                return false;

            if (btn.data('cc') == '1' || (G.channel == 1 || G.channel == 7)) {
                form.find('.confirmation-button').addClass('hidden');
                form.find('.confirmation-success-send').addClass('hidden');
                form.find('.user-register').removeClass('hidden');
                form.find('.user-register select:not([name=region_guid])').select2({minimumResultsForSearch: Infinity});
                form.find('.user-register select[name=region_guid]').select2({
                    placeholder: __("Назва бізнес регіону..."),
                    minimumInputLength: 3,
                    width: "15em",
                    ajax: {
                        url: '/aj',
                        type: "POST",
                        dataType: "json",
                        data: function (term) {
                            return {
                                term: term['term'],
                                action: 'basket',
                                to: 'regions',
                            };
                        },
                        processResults: function (data, page) {
                            return {
                                results: data
                            };
                        }
                    }
                });
                form.find('.user-register').find('[name=cc]').val(1);
                $(".cart .scroll .error-alert").addClass('hidden');
                SLR.possible_submit();

                return false;
            }

            form.find('.confirmation-success-send').addClass('hidden');
            SLR.smstrycount++;
            btn.removeClass('success').addClass('cancel');

            $.post(
                '/aj',
                {
                    action: 'slr',
                    to: 'sendcode',
                    locale: G.locale_id,
                    counter: SLR.token_counter,
                    source: btn.data('source'),
                    phone: phone.val()
                },
                function (data) {
                    if (data.success) {
                        form.find('.confirmation-field').removeClass('hidden').find('input').val('');
                        form.find('.confirmation-success-send').removeClass('hidden').html(data.message);
                        btn.data('source', '1');

                        SLR.token_counter++;
                        SLR.token = data.token;
                        SLR.startSmsTimer();
                    } else {
                        SLR.token = '';
                        form.parent().find('.confirmation-success-send').removeClass('hidden').html(data.message);
                    }
                },
                'json');
        });

        // Проверка кода смс, slr регистрация
        jQuery("body").on("keyup", ".cart.ok .confirmation-field input", function (e) {
            e.preventDefault();
            let input = $(this);
            let form = $(".cart.ok form");
            let phone = form.find("[name=phone]");
            let code = $.trim(input.val());

            if (input.val().length == 4) {
                $.post(
                    '/aj',
                    {
                        action: 'slr',
                        to: 'checkcode',
                        login: -1,
                        token: SLR.token,
                        locale: G.locale_id,
                        code: code,
                        phone: phone.val()
                    },
                    function (data) {
                        if (data.success) {
                            form.find('.confirmation-button').addClass('hidden');
                            form.find('.confirmation-success-send').addClass('hidden');
                            form.find('.user-register').removeClass('hidden');
                            form.find('.user-register select').select2({minimumResultsForSearch: Infinity});
                        } else {
                            form.parent().find('.confirmation-success-send').removeClass('hidden').html(data.message);
                        }

                        $(".cart .scroll .error-alert").addClass('hidden');

                        SLR.possible_submit();
                    },
                    'json');
                return;
            }
            return false;
        });

        // Отмена регистрации пользователя
        jQuery("body").on("click", ".cancel-register", function (e) {
            e.preventDefault();
            $(".user-register").addClass('hidden');
            $('.cart.ok [name=phone]').trigger('keyup');

            $(".cart .scroll .error-alert").addClass('hidden');

            SLR.possible_submit();
        });

        // Регистрация пользователя
        jQuery("body").on("click", ".submit-register", function (e) {
            e.preventDefault();

            var btn = $(this);
            var form = btn.parents('form');

            var ec = 0;
            var phone = form.find("[name=phone]");
            var name1 = form.find("[name=name_1]");
            var name2 = form.find("[name=name_2]");
            var name3 = form.find("[name=name_3]");
            var day = form.find("[name=day]");
            var month = form.find("[name=month]");
            var year = form.find("[name=year]");
            var sex = form.find("[name=sex]");

            if ($.trim(name1.val()).length < 2) {
                name1.parent().find('label span').removeClass('hidden');
                ec++;
            } else
                name1.parent().find('label span').addClass('hidden');

            if ($.trim(name2.val()).length < 2) {
                name2.parent().find('label span').removeClass('hidden');
                ec++;
            } else
                name2.parent().find('label span').addClass('hidden');

            if ($.trim(sex.val()).length < 1) {
                sex.parent().find('label span').removeClass('hidden');
                ec++;
            } else
                sex.parent().find('label span').addClass('hidden');

            if (day.val() > 0 || month.val() > 0) {
                if (!(day.val() > 0 && month.val() > 0)) {
                    day.parent().parent().find('label span').removeClass('hidden');
                    ec++;
                } else {
                    day.parent().parent().find('label span').addClass('hidden');
                }
            }

            if (ec || btn.hasClass('loading'))
                return false;

            btn.html('Обробляємо').addClass('loading');

            $.ajax({
                type: "POST",
                url: '/slr/registeruser',
                data: {
                    to: 'registeruser',
                    phone: phone.val(),
                    name_1: $.trim(name1.val()),
                    name_2: $.trim(name2.val()),
                    name_3: $.trim(name3.val()),
                    day: form.find("[name=day]").val(),
                    month: form.find("[name=month]").val(),
                    year: form.find("[name=year]").val(),
                    sex: form.find("[name=sex]").val(),
                    region_guid: form.find("[name=region_guid]").val(),
                    cc: form.find("[name=cc]").val()
                },
                dataType: "json",
                timeout: 30000, // in milliseconds
                success: function (data) {
                    btn.removeClass('loading');

                    if (data.success) {
                        form.find('[name=phone]').parent().parent().find('label span').addClass('hidden');

                        $.post(
                            '/slr/lastclients',
                            {
                                to: 'lastclients',
                            },
                            function (result) {
                                if (!$(".client-finder .client-list .last-clients-container").length)
                                    $(".client-finder .client-list").append('<div class="last-clients-container"></div>');

                                $(".last-clients-container").replaceWith(result.html);
                                $(".last-clients-container [data-code=" + $.trim(data.code) + "]").trigger('click');
                            },
                            'json'
                        );

                        $(".user-register").addClass('hidden');
                    } else {
                        btn.html('Реєстрація').removeClass('cancel').addClass('success');
                        form.find('.confirmation-success-send').addClass('alert-danger').removeClass('hidden').html(data.error);
                    }

                    $(".cart .scroll .error-alert").addClass('hidden');

                    SLR.possible_submit();
                },
                error: function (request, status, err) {
                    form.find('.confirmation-success-send').removeClass('hidden').html('Помилка! ' + data.error + '<br />Нажміть Скасувати для продовження');
                }
            });

        });

        // switch вариант обеспечения
        jQuery("body").on("click", ".cart.ok .sticker-shop, .cart.ok .sticker-truck", function (e) {
            e.preventDefault();
            let btn = $(this);
            let sku = btn.parents('.cart__item').data('sku');
            $.post(
                '/aj',
                {
                    action: 'slr',
                    to: 'changeprovision',
                    sku: sku
                },
                () => {
                    CARD.updatePromise();
                },
                'json'
            );
            return false;
        });

        // switch my store
        jQuery("body").on("click", ".switch-store", function (e) {
            e.preventDefault();
            CABINET.switch_store($(this).data('was')).then(() => document.location.reload());
        });

        jQuery("body").on("click", ".print-invoice-form .services-list a", function (e) {
            e.stopPropagation();
            e.preventDefault();

            let btn = $(this);

            if (btn.hasClass('active')) {
                btn.removeClass('active');

                if (btn.hasClass('for-print'))
                    $(".print-invoice-form [name=print]").val(0);

                if (btn.hasClass('for-email'))
                    $(".print-invoice-form [name=send_email]").val(0);

            } else {
                btn.addClass('active');

                if (btn.hasClass('for-print'))
                    $(".print-invoice-form [name=print]").val(1);

                if (btn.hasClass('for-email'))
                    $(".print-invoice-form [name=send_email]").val(1);
            }

        });

        jQuery("body").on("click", ".js-print-invoice-form", function (e) {
            e.preventDefault();
            e.stopPropagation();

            let form = $(this).parents('form');
            let print = form.find('[name=print]').val();
            let email = form.find('[name=email]').val();

            if (!(form.find('[name=send_email]').val() == 1))
                email = '';

            if (form.find('[type=submit]').hasClass('loading')) {
                return;
            }

            form.find('[type=submit]').addClass('loading');

            $.post(
                '/aj',
                {
                    action: 'slr',
                    to: 'printinvoice',
                    id: form.find('[name=id]').val(),
                    print: print,
                    email: email,
                },
                function (data) {
                    form.replaceWith('<div class="clearfix"></div><br /><div class="alert">Рахунок відправлено</div>');
                },
                'json');

            return;
        });

        // daypromo contexts
        $(".cabinet .promo__main .blog-categories a").click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);
            let on = btn.hasClass('active') ? false : true;

            btn.parent().find('a').removeClass('active');
            btn.addClass('active');

            if (SLR.promo_data == '')
                SLR.promo_data = $(".promo__biglist").html();

            if (on) {
                $(".promo__biglist").empty().html(SLR.promo_data);

                if (!(btn.data('context') == 0))
                    $(".promo__biglist >div:not([data-context*=" + btn.data('context') + "])").remove();
            } else {
                $(".promo__biglist").empty().html(SLR.promo_data);
            }
        });

        // slr sms auth
        $(".send-slr-sms").click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);
            let form = btn.parents('form');

            if (btn.hasClass('loading'))
                return;

            btn.addClass('loading');

            $.post(
                '/aj',
                {
                    action: 'slr',
                    to: 'smsauth',
                    phone: form.find('[name=phone]').val(),
                },
                function (data) {
                    btn.removeClass('loading');
                    form.find('.slr-sms-form').removeClass('hidden');
                    form.find('.alert').html(data.message).removeClass('hidden');
                    if (data.success) {
                        form.find('.alert').removeClass('alert-danger');
                    } else {
                        form.find('.alert').addClass('alert-danger');
                    }
                },
                'json'
            );
        });

        // slr sms code keyup
        jQuery("body").on("keyup", ".slr-sms-auth [name=smscode]", function (e) {
            let input = $(this);
            let form = input.parents('form');

            if ($.trim(input.val()).length == 4) {

                $.post(
                    '/aj',
                    {
                        action: 'slr',
                        to: 'login',
                        process: 'check',
                        phone: form.find('[name=phone]').val(),
                        code: form.find('[name=smscode]').val(),
                    },
                    function (data) {
                        if (data.success) {
                            document.location.assign('/slr');
                        } else {
                            form.find('.alert').html('Код не вірний').removeClass('hidden');
                        }
                    },
                    'json'
                );
            }
        });

        // check, step 1 paste
        jQuery("body").on("paste change autocompleteSelect", ".wrap-client input[name=phone]", function (e) {
            e.preventDefault();
            e.stopPropagation();
            let input = $(this);

            if (e.type == "change") {
                let newval = input.val();

                if (newval.substr(0, 4) == '+380')
                    newval = newval.substr(3);

                if (newval.substr(0, 3) == '380')
                    newval = newval.substr(2);
                input.val(newval);
            }

            if (e.type == "paste") {
                let newval = e.originalEvent.clipboardData.getData('text');

                if (newval.substr(0, 4) == '+380')
                    newval = newval.substr(3);

                if (newval.substr(0, 3) == '380')
                    newval = newval.substr(2);

                input.val(newval);
            }

            // if (!(typeof e.originalEvent === "undefined"))
            //     input.trigger('keyup');
        });

        jQuery("body").on("click", ".js-cart__upsalemystore", function (e) {
            e.preventDefault();
            let btn = $(this);
            btn.toggleClass('checked');
            CARD.load_upsale_window(btn.data('sku'))
        });

        jQuery("body").on("click", ".js-promo__slrdetails", function (e) {
            e.preventDefault();
            let btn = $(this);
            btn.toggleClass('promo__slrdetails-opened');
        });

        jQuery("body").on("click", ".js-slr__downloadpriceplatepdf", function (e) {
            e.preventDefault();
            let form = $(".js-slr__downloadpriceplateform");

            form.find('[name=sku]').val($(".printer-form [name=sku]").val());
            form.find('[name=template]').val($(".printer-form [name=template]").val());

            form.submit();
        });

        jQuery("body").on("click", ".js-loop__slrunrelevant", function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);
            let form = $(".js-slr__searchrateform");

            $.post(
                '/aj',
                {
                    action: 'slr',
                    to: 'unrelevantsearch',
                    log_id: form.find('[name=spacesearch_log_id]').val(),
                    position: btn.data('position'),
                    title: btn.parents('.loop').find('.loop__title').text()
                },
                function (data) {
                    WARNING.info('Дякуємо')
                },
                'json'
            );
        });

        jQuery("body").on("click", ".js-slr__searchratebtn", function (e) {
            e.preventDefault();
            $(".js-slr__searchrateform").toggleClass('hidden');
        });

        jQuery("body").on("submit", ".js-slr__searchrateform", function (e) {
            e.preventDefault();
            let form = $(this);

            $.post(
                '/aj',
                {
                    action: 'slr',
                    to: 'ratesearch',
                    log_id: form.find('[name=spacesearch_log_id]').val(),
                    rate: form.find('[name=rate]:checked').val(),
                    comment: form.find('[name=comment]').val(),
                },
                function (data) {
                    WARNING.info('Дякуємо')
                    $(".js-slr__searchratebtn").trigger('click');
                    form.trigger('reset');
                },
                'json'
            );
        });

        // camera
        jQuery("body").on('change', '.camera-layout__select', function (e) {
            SLR.selectedDeviceId = $(this).val();
            SLR.codeReader.reset();
            $(".camera-layout__start").trigger('click');
        });

        jQuery("body").on('click', '.camera-layout__start', function (e) {
            try {
                SLR.codeReader.decodeFromVideoDevice(SLR.selectedDeviceId, 'video', (result, err) => {
                    if (result) {
                        if (this.cameraLoading)
                            return;

                        if (!SLR.addBlocked) {
                            SLR.addBlocked = true;

                            console.log('scan result', result.text);

                            setTimeout(function () {
                                SLR.addBlocked = false;
                            }, 1000);

                            if (result.text.substring(0, 20)=='https://ktc.ua/qr/c/') {
                                console.log('lookup client', result.text.substring(20));
                                SLR.lookupClientByGuid(result.text.substring(20));
                            } else {
                                SLR.add_qr_sku(result.text);
                            }
                        }
                    }
                    if (err && !(err instanceof ZXing.NotFoundException)) {
                        console.error(err)
                        document.getElementById('someres').textContent = err
                    }
                }, { video: { focusMode: "continuous" } });
            } catch (e) {
            }
            console.log(`Started continous decode from camera with id ${SLR.selectedDeviceId}`)
        });

        jQuery("body").on('click', '.camera-layout__reset', function (e) {
            SLR.codeReader.reset();
            console.log('Reset.')
        });

        jQuery("body").on('click', '.qr-sku-search', function (e) {
            e.preventDefault();

            let container = $(".cart").length > 0 ? $(".cart") : $("body");

            if (!$(".camera-layout", container).length)
                container.append(
                    '<div class="camera-layout" id="cameraLayout">' +
                    '   <div>' +
                    '        <div class="camera-loader"></div>' +
                    '        <div style="display: none">\n' +
                    '            <a class="button camera-layout__start">Start</a>\n' +
                    '            <a class="button camera-layout__reset">Reset</a>\n' +
                    '        </div>' +
                    '        <div class="camera-layout__camera">\n' +
                    '            <label for="sourceSelect">Камера:</label>\n' +
                    '            <select id="sourceSelect" class="camera-layout__select"></select>\n' +
                    '        </div>\n' +
                    '        <div class="camera-layout__video">\n' +
                    '            <video id="video" width="100%" height="350"></video>\n' +
                    '        </div>\n' +
                    '        <div class="camera-layout__results"></div>\n' +
                    '        <div class="camera-layout__buttons">\n' +
                    '            <button class="btn camera-layout__add">Додати</button>\n' +
                    '            <button class="btn unsuccess camera-layout__close">Скасувати</button>\n' +
                    '            <div class="camera-layout__beta">Beta<br />Версія</div>\n' +
                    '        </div>\n' +
                    '   </div>' +
                    '</div>');

            U.loadscript("/themes/js/qrcode.min.js", () => {
                SLR.codeReader = new ZXing.BrowserMultiFormatReader()
                console.log('ZXing code reader initialized')
                SLR.codeReader.listVideoInputDevices()
                    .then((videoInputDevices) => {
                        const sourceSelect = $(".camera-layout__select");
                        sourceSelect.append('<option value="">По замовчуванню</option>');
                        SLR.selectedDeviceId = '';

                        if (videoInputDevices.length >= 1) {
                            videoInputDevices.forEach((element) => {
                                let selected = false;
                                // if (element.label.match(/back/gi)) {
                                    // SLR.selectedDeviceId = element.deviceId;
                                    // selected = true;
                                // }
                                sourceSelect.append('<option value="' + element.deviceId + '" ' + (selected ? 'selected' : '') + '>' + element.label + '</option>');
                            });

                            $(".camera-layout__start").trigger('click');
                        }

                    })
                    .catch((err) => {
                        console.error(err);
                        $("#someres").text = err;
                    })
                //
                // setTimeout(() => {
                //     SLR.lookupClientByGuid('123');
                // }, 3000);
            });

            // $(".cart .camera-layout").empty().removeClass('hidden');
        });

        jQuery("body").on('click', '.qrcode-sku-search', function (e) {
            e.preventDefault();

            if (!$("body .camera-layout").length)
                $("body").prepend('' +
                    '<div class="body-camera-layout" id="cameraLayout">' +
                    '   <div>' +
                    '        <div style="display: none">\n' +
                    '            <a class="button camera-layout__start">Start</a>\n' +
                    '            <a class="button camera-layout__reset">Reset</a>\n' +
                    '        </div>' +
                    '        <div class="camera-layout__camera">\n' +
                    '            <label for="sourceSelect">Камера:</label>\n' +
                    '            <select id="sourceSelect" class="camera-layout__select"></select>\n' +
                    '        </div>\n' +
                    '        <div class="camera-layout__video">\n' +
                    '            <video id="video" width="100%" height="350"></video>\n' +
                    '        </div>\n' +
                    '        <div class="camera-layout__results"></div>\n' +
                    '        <div class="camera-layout__buttons">\n' +
                    '            <button class="btn camera-layout__add" data-to="printer">Додати</button>\n' +
                    '            <button class="btn unsuccess camera-layout__close">Скасувати</button>\n' +
                    '            <div class="camera-layout__beta">Beta<br />Версія</div>\n' +
                    '        </div>\n' +
                    '   </div>' +
                    '</div>');

            U.loadscript("/themes/js/qrcode.min.js", () => {
                SLR.codeReader = new ZXing.BrowserMultiFormatReader()
                console.log('ZXing code reader initialized')
                SLR.codeReader.listVideoInputDevices()
                    .then((videoInputDevices) => {
                        const sourceSelect = $(".camera-layout__select");
                        SLR.selectedDeviceId = videoInputDevices[0].deviceId;

                        if (videoInputDevices.length >= 1) {
                            videoInputDevices.forEach((element) => {
                                let selected = false;
                                if (element.label.match(/back/gi)) {
                                    SLR.selectedDeviceId = element.deviceId;
                                    selected = true;
                                }
                                sourceSelect.append('<option value="' + element.deviceId + '" ' + (selected ? 'selected' : '') + '>' + element.label + '</option>');
                            });

                            $(".camera-layout__start").trigger('click');
                        }

                    })
                    .catch((err) => {
                        console.error(err);
                        $("#someres").text = err;
                    })
            });

            // $(".cart .camera-layout").empty().removeClass('hidden');
        });

        jQuery("body").on('click', '.camera-layout__close', function (e) {
            e.preventDefault();
            $(".cart .camera-layout, body > .camera-layout, .body-camera-layout").remove();

            try {
                SLR.codeReader.reset();
            } catch (e) {}
        });

        jQuery("body").on('click', '.camera-layout__add', function (e) {
            e.preventDefault();

            let btn = $(this);
            let skus = [];

            if ($(".camera-layout__sku").length > 0)
                $.each($(".camera-layout__sku"), function (i, item) {
                    item = $(item);
                    skus.push(item.data('sku'));
                });

            $(".camera-layout__video").remove();

            if (skus.length > 0) {
                if ($(".camera-layout__sku").parents('.cart').length > 0) {
                    CARD.add(skus.join(','), 1, 'qrscanner', false, 1, function () {
                        $(".cart .camera-layout").remove();
                    });
                } else {
                    if (btn.data('to') == 'printer') {
                        $(".printer-form [name=sku]").val(skus.join(', '));
                    }

                    if (btn.data('to') == 'selected-showcase') {
                        let code = skus.join(', ');
                        $.ajax({
                            type: "POST",
                            url: "/aj",
                            data: {
                                action: 'slr',
                                to: 'skudetail',
                                val: code,
                            },
                            dataType: "json",
                            timeout: 15000, // in milliseconds
                            success: function (data) {
                                SLR.setCameraLoader(false);
                                SHOWCASE.selected_showcase.html('<img src="' + data.product.image + '" />');
                            },
                            error: function (data) {
                                alert('Код не розпізнано: ' + code);
                                SLR.setCameraLoader(false);
                            }
                        });
                    }

                    $(".cart .camera-layout, .body-camera-layout").remove();
                }
            } else
                $(".cart .camera-layout, .body-camera-layout").remove();

            try {
                SLR.codeReader.reset();
            } catch (e) {
                console.log(e);
                SLR.setCameraLoader(false);
            }
        });

    });

    jQuery("body").on('click', '.js-cameraclient__close', function(e) {
        e.preventDefault();
        $(".cameraclient").remove();
    });

    jQuery("body").on('click', '.js-cameraclient__yes', function(e) {
        e.preventDefault();

        CARD.postData({
            action: 'slr',
            to: 'saveselectedclient',
            code: SLR.finded_client.code,
            name: SLR.finded_client.name,
        }).finally(() => {
            $(".cameraclient").remove();
            $(".camera-layout__close").trigger('click');

            if ($(".cart").length > 0) {

                if ($(".wrap-client").length > 0) {
                    $(".go-checkout").trigger('click');
                }
            } else {
                document.location.assign('/slr/orders');
            }
        });
    });

    $("body").on('keyup', '.slr-exchangeform input', function (e) {
        e.preventDefault();
        let input = $(this);

        if (input.attr('name')=='imei' || input.attr('name')=='passport') {
            SLR.write_exchange_storage($('.slr-exchangeform [name=imei]').val(), $('.slr-exchangeform [name=passport]').val());
        }
    });

    $("body").on('click', '.js-slr-ex__sendbutton, .js-slr-ex__sendbutton-repurchase', function (e) {
        e.preventDefault();
        const repurchase = $(this).hasClass('js-slr-ex__sendbutton-repurchase') ? 1 : 0;

        if ($(".js-ex__question .js-ex__questionsubmit").length > 0) {
            return;
        }

        // open dialog
        DRAWER.init('workdrawer-slr-exchange', {
            action: 'exchange',
            to: 'popup',
            repurchase
        }, () => {
            SLR.fill_exchange_storage();
            U.mask_inputs();
        });
    });

    $("body").on('keyup', '.js-cart__searchcart', function (e) {
        const input = $(this);
        const val = $.trim(input.val()).toLowerCase();

        if (val!='') {
            if ($(".cart-list >div").length > 0) {
                $.each($(".cart-list >div"), function(i, item) {
                    item = $(item);

                    if (item.data('phone').toString().toLowerCase().match(val) || item.find('.user-name').text().toString().toLowerCase().match(val)) {
                        item.removeClass('hidden');
                    } else {
                        item.addClass('hidden');
                    }
                })
            }
        } else {
            $(".cart-list >div").removeClass('hidden');
        }
    });

    $("body").on('click', '.js-clearcart', function (e) {
        e.preventDefault();

        const btn = $(this);
        SLR.set_client(0, '');
        $(".change-cart").trigger('click');
    });

    $("body").on('click', '.slr-cart__searchcart > a', function (e) {
        e.preventDefault();
        $(".js-cart__searchcart").blur();
    });

    $("body").on('change', '.js-slrproceedcheckout input', function (e) {
        const btn = $(this);

        CARD.postData({
            action: 'basket',
            to: 'save_process_checkout',
            process_checkout: btn.prop('checked') ? 1 : 0
        }).then(() => {

        });
    });

    $("body").on('submit', '.js-unpack-form', function (e) {
        e.preventDefault();
        const form = $(this);
        const sku = $.trim(form.find('[name=sku]').val());

        UNPACK.lookupsku(sku, form);
    });

    $("body").on('click', '.js-unpack-unpackbtn', function (e) {
        e.preventDefault();

        DRAWER.init('workdrawer-slr-unpack', {
            action: 'slr',
            to: 'unpack',
            sku: $('.js-unpack-form [name=sku]').val(),
            product: JSON.stringify(UNPACK.productCache)
        }, () => {
            UNPACK.filterSerialNumbers();
            $(".workdrawer-slr-unpack select").select2({minimumResultsForSearch: Infinity});
        }, false, '/slr/unpack/popup');
    });

    $("body").on('keyup', '.js-unpack-filterserial', function (e) {
        const input = $(this);
        UNPACK.filterSerialNumbers(input.val());
    });

    $("body").on('click', '.js-unpack-info', function (e) {
        e.preventDefault();
        const btn = $(this);

        if (btn.prop('disabled')) {
            return;
        }

        btn.prop('disabled', true).addClass('btn-loading');

        JOBS.init_JOB(
            '/slr/unpack/lookupsku',
            {
                action: 'slr',
                to: 'unpack',
                sku: btn.data('sku')
            },
            (res) => {

                if (res.success) {
                    UNPACK.productCache = res.product;

                    DRAWER.init('workdrawer-slr-unpack', {
                        action: 'slr',
                        to: 'unpack',
                        sku: $('.js-unpack-form [name=sku]').val(),
                        product: JSON.stringify(UNPACK.productCache)
                    }, () => {
                        // UNPACK.filterSerialNumbers();
                        // $(".workdrawer-slr-unpack select").select2({minimumResultsForSearch: Infinity});
                    },  false, '/slr/unpack/popup');

                } else {
                    console.error(res);
                }


            },
            (result) => {
            },
            () => {
                btn.prop('disabled', false).removeClass('btn-loading');
            }
        );
    });

    $("body").on('click', '.js-unpack-unpackserial', function (e) {
        e.preventDefault();

        const el = $(".js-unpack-serialslist >a:not(.hidden)");
        const ss = el.data('sn_guid');

        $(".js-unpack-choiseform").addClass('hidden');
        $(".js-unpack-sendform").removeClass('hidden').find('[name=sn_guid]').val(ss);
        $(".js-unpack-sendform").removeClass('hidden').find('[name=opened]').val(el.data('opened'));
    });

    $("body").on('click', '.js-unpack-sendunpack', function (e) {
        e.preventDefault();

        const btn = $(this);
        const form = $(".js-unpack-sendform");
        const comment = $.trim(form.find('[name=comment]').val());
        const reason = $.trim(form.find('[name=reason]').val());
        const opened = parseInt(form.find('[name=opened]').val());

        if (reason=='' && comment=='') {
            form.find('.alert').removeClass('hidden').html('Вкажіть тип розпаковки та коментар');
            return;
        }

        form.find('.alert').addClass('hidden');

        if (btn.prop('disabled')) {
            return;
        }

        btn.prop('disabled', true).addClass('loading');

        UNPACK.send()
            .then(res => {
                if (res.success) {
                    DRAWER.destroy();
                    short_popup(res.html);
                } else {
                    form.find('.alert').removeClass('hidden').html(res.error_message);
                }
            })
            .catch(err => {
                form.find('.alert').removeClass('hidden').html('Помилка при відправленні запиту. 1с не відповідає. Спробуйте ще раз');
            })
            .finally(() => {
                btn.prop('disabled', false).removeClass('loading');
            });
    });

    $("body").on('submit', '.slr-exchangeform', function (e) {
        e.preventDefault();
        let form = $(this);
        let submit = form.find('[type=submit]');
        let errors = 0;
        let message = '';

        if (submit.hasClass('disabled')) {
            return;
        }

        const code = parseInt(form.find('[name=code]').val());

        if (!(code > 0)) {
            message = `Оберіть кліента`;
            errors++;
        }

        if (form.find('[name=process]').prop('checked')) {
            if (form.find('[name=imei]').val().length < 5) {
                errors++;
                message = `Серійний номер обов'язковий`;
                form.find('[name=imei]').parent().find('label span').removeClass('hidden');
            } else {
                form.find('[name=imei]').parent().find('label span').addClass('hidden');
            }

            if (form.find('[name=passport]').val().length < 5) {
                errors++;
                message = `Серія та номер паспорта обов'язковий`;
                form.find('[name=passport]').parent().find('label span').removeClass('hidden');
            } else {
                form.find('[name=passport]').parent().find('label span').addClass('hidden');
            }
        }

        if (errors > 0) {
            form.find('>div >.alert').html(message).removeClass('hidden');
        } else {
            form.find('>div >.alert').addClass('hidden');
            submit.addClass('disabled loading');

            SLR.clear_exchange_storage();

            EX.send_device({
                passport: form.find('[name=passport]').val(),
                imei: form.find('[name=imei]').val(),
                process: form.find('[name=process]').prop('checked') ? 1 : 0,
                repurchase: parseInt(form.find('[name=repurchase]').val()),
            });
        }
    });

    jQuery("body").on('keyup', '.js-unpack-form input', function (e) {
        const input = $(this);
        UNPACK.filter_goods(input.val());
    });

    jQuery("body").on('click', '.js-unpack-togglecategories', function (e) {
        e.preventDefault();
        $(".js-unpack-categories").toggleClass('hidden');
    });

    jQuery("body").on('click', '.js-unpack-selectcontext', function (e) {
        e.preventDefault();
        const btn = $(this);

        if (btn.hasClass('btn-category-active')) {
            btn.removeClass('btn-category-active');
            $(".js-looplist .loop").removeClass('hidden');
        } else {
            $('.js-unpack-selectcontext').removeClass('btn-category-active');
            $(".js-looplist .loop").addClass('hidden');
            $(`.js-looplist .loop[data-context=${btn.data('context')}]`).removeClass('hidden');
            btn.addClass('btn-category-active');
        }

        $('.js-unpack-form input').trigger('change');
    });

    init_CF_events();

}

init_SLR_events();